import { rgba } from 'polished';
import styled from 'styled-components';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { Link } from 'react-router-dom';

const StyledContainer = styled.div`
  flex: 0 0 150px;
  margin: 0 11px 40px;
`;

const StyledImageContainer = styled.div`
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
  border-radius: 4px;
  overflow: hidden;
`;

const StyledItemCountContainer = styled.p`
  ${typeStyle['font-12']};
  color: ${rgba(theme.color.white, 0.7)};
  margin-bottom: 7px;
`;

const StyledTitle = styled.h3`
  ${typeStyle.h2};
  position: relative;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  max-width: 120px;
`;

const StyledBoardOptions = styled.button`
  position: absolute;
  top: 0;
  right: 0;
`;

export {
  StyledContainer,
  StyledImageContainer,
  StyledItemCountContainer,
  StyledTitle,
  StyledBoardOptions,
  StyledLink,
};
